import http from '@/plugins/axios';

export default {
  getEssentialData: () => http.get('/dashboard-essential-data'),
  getAccountInfo: () => http.get('/account'),
  getMetafieldsJsons: () => http.get('/metafields-data-jsons'),
  getMetafieldsJsonsExample: () => http.get('/metafields-data-jsons-example'),
  getInstallationInfo: () => http.get('/installation-status'),
  postStepWizard(step_name) {
    return http.post('/onboarding-mark-finished', { step_name });
  },
  postReadFreePlanOffer: () => http.post('/mark-read-wizard-free-plan-offer'),
  uninstallOpinew: () => http.post('/uninstall'),
  exportReviews: () => http.get('/export-reviews'),
  getSMSSettings: () => http.get('/get-sms-settings'),
  getSMSPlansPriceList: () => http.get('/get-sms-price-list'),

  saveDiscountCode(code) {
    return http.post('/redeem-offer', { code });
  },
  postActivateSmsReviewRequest() {
    return http.post('/activate-sms-review-requests');
  },
  setFacebookPageId(facebookPageId) {
    return http.post('/facebook-integration', { facebookPageId });
  },
  deleteFacebookPageId() {
    return http.post('/delete-facebook-integration');
  },
  postDeactivateSmsReviewRequest() {
    return http.post('/deactivate-sms-review-requests');
  },
  postSetSmsPriceLimit(smsPriceLimit) {
    return http.post('/set-sms-price-limit', { smsPriceLimit });
  },
  setImporterProfiles(importerProfiles) {
    const data = {
      importerProfiles,
    };
    return http.post('/set-importer-profiles', data).then(res => res.data);
  },
  hideExtensionAnalytics() {
    return http.post('/hide-extension-analytics');
  },
  hideTalkToExperts() {
    return http.post('/hide-talk-to-experts');
  },
  hideRequestAppStoreReviewWidget() {
    return http.post('/hide-request-app-store-review-widget');
  },
  hideRequestAppStoreReviewModal() {
    return http.post('/hide-request-app-store-review-modal');
  },
  toggleAddon(addonName) {
    return http.post('/toggle-addon', { addonName });
  },
  loadSmartReviewsData: () => http.get('/smart-reviews-data').then(res => res.data),
  activateSmartReviewsOffer: () => http.get('/activate-smart-reviews-offer').then(res => res.data),
  setSmartReviewsTesting(enabled) {
    return http.post('/plugin-ab-test', { enabled }).then(res => res.data);
  },
  sendReferralInvitationEmail(payload) {
    return http.post('/send-referral-email', payload).then(res => res.data);
  },
  sendInstallationInstructionsEmail(payload) {
    return http.post('/send-installation-instructions', payload).then(res => res.data);
  },

  setReferralLeaderboard(payload) {
    return http.post('set-referral-leaderboard', payload).then(res => res.data);
  },
  updateNoReviewsGuideCount: () => http.post('update-no-reviews-guide-count'),
  updateGetStartedSteps(data) {
    return http.post('/get-started-steps', data);
  },
  updateFreshchatData(data) {
    return http.post('/update-freshchat-data', data);
  },
};
